import React, {Component} from 'react'

class Chat extends Component {
    render() {
        return <div className="chat"></div>;
    }
}

export default Chat;


// WEBPACK FOOTER //
// ./src/components/base/Chat/index.js